import React from "react";
import Marquee from "react-fast-marquee";
import X from "../../Asset/X.svg";
import whatsapp from "../../Asset/whatsapp.svg";
import telegram from "../../Asset/telegram.svg";
import signal from "../../Asset/signal.svg";
import gpt from "../../Asset/gpt.svg";
import message from "../../Asset/message.svg";
import slack from "../../Asset/slack.svg";
import instagram from "../../Asset/instagram.svg";
import messenger from "../../Asset/messenger.svg";
import iosMail from "../../Asset/ios mail.svg";
import gmail from "../../Asset/gmail.svg";
import team from "../../Asset/team.svg";
import outLook from "../../Asset/outLook.svg";
import iosNotes from "../../Asset/ios notes.svg";
import googleDocs from "../../Asset/docs.svg";
import { ReactSVG } from "react-svg";

const IconMarquee = ({ text, subtext }) => {
  const icons = [
    {
      icon: whatsapp,
      title: "WhatsApp",
    },
    {
      icon: X,
      title: "X (Twitter)",
    },
    {
      icon: telegram,
      title: "Telegram",
    },
    {
      icon: signal,
      title: "Signal",
    },
    {
      icon: gpt,
      title: "ChatGPT",
    },
    {
      icon: message,
      title: "Messages",
    },
    {
      icon: slack,
      title: "Slack",
    },
    {
      icon: instagram,
      title: "Instagram",
    },
    {
      icon: messenger,
      title: "Messenger",
    },
    {
      icon: iosMail,
      title: "Apple Mail",
    },
    {
      icon: gmail,
      title: "Gamil",
    },
    {
      icon: team,
      title: "Microsoft Teams",
    },

    {
      icon: outLook,
      title: "Outlook",
    },
    {
      icon: iosNotes,
      title: "Apple Notes",
    },
    {
      icon: googleDocs,
      title: "Google Docs",
    },

    {
      icon: whatsapp,
      title: "WhatsApp",
    },
    {
      icon: X,
      title: "X (Twitter)",
    },
    {
      icon: telegram,
      title: "Telegram",
    },
    {
      icon: signal,
      title: "Signal",
    },
    {
      icon: gpt,
      title: "ChatGPT",
    },
    {
      icon: message,
      title: "Messages",
    },
    {
      icon: slack,
      title: "Slack",
    },
    {
      icon: instagram,
      title: "Instagram",
    },
    {
      icon: messenger,
      title: "Messenger",
    },
    {
      icon: iosMail,
      title: "Apple Mail",
    },
    {
      icon: gmail,
      title: "Gamil",
    },
    {
      icon: team,
      title: "Microsoft Teams",
    },

    {
      icon: outLook,
      title: "Outlook",
    },
    {
      icon: iosNotes,
      title: "Apple Notes",
    },
    {
      icon: googleDocs,
      title: "Google Docs",
    },
  ];

  return (
    <div className=" flex flex-col items-center justify-center gap-4">
      <div className="flex flex-col items-center gap-2">
        <div className=" text-[#002433] text-center font-medium font-jakarta md:text-[1.438rem] text-[1.313rem]">
          {text}
        </div>
        {subtext && (
          <div className="text-[#00000099] text-center font-inter leading-snug md:text-[1.15rem] text-[1rem] max-w-4xl">
            {subtext}
          </div>
        )}
      </div>
      <Marquee direction="left" pauseOnHover className="text-black py-2">
        {icons.map((icon, i) => (
          <div
            key={i}
            title={icon.title}
            className=" ml-4  shadow-md rounded-2xl"
          >
            <ReactSVG
              src={icon.icon}
              beforeInjection={(svg) => {
                svg.setAttribute(
                  "class",
                  "xl:w-[4rem] lg:w-[3.6rem] md:w-[3.2rem] w-[2.8rem] xl:h-[4rem] lg:h-[3.6rem] md:h-[3.2rem] h-[2.8rem]"
                );
              }}
            />
          </div>
        ))}
      </Marquee>
    </div>
  );
};

export default IconMarquee;
